import { forwardRef, Inject, Pipe, PipeTransform } from '@angular/core';
import { DigitalServiceService } from '../../service/digital-service.service';

@Pipe({ name: 'planLabel' })
export class PlanLabelPipe implements PipeTransform {

    constructor(@Inject(forwardRef(() => DigitalServiceService)) private digitalServiceService: DigitalServiceService) { }

    transform(planName: string, partner?: boolean): any {
        if (!planName) {
            return '';
        }
        return this.digitalServiceService.getPlanLabel(planName, partner);
    }
}